<template>
  <div class="confirmation main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Confirmações de Agendamentos</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-4">
          <b-col>
            <label class="cj-label">Período</label>
            <date-range-picker
              class="w-100"
              ref="picker"
              :opens="'right'"
              :ranges="false"
              :localeData="dateRangePickerPtBrLocale"
              :showDropdowns="true"
              v-model="confirmationForm.dateTime">
              <div slot="input" slot-scope="picker" class="">
                {{ moment(picker.startDate).format('DD/MM/YYYY') }} - {{ moment(picker.endDate).format('DD/MM/YYYY') }}
              </div>
            </date-range-picker>
          </b-col>
          <b-col>
            <label class="cj-label">Agenda</label>
            <multiselect v-model="confirmationForm.agenda" :options="agendas" track-by="name" label="name" :showLabels="false" placeholder="Selecione"></multiselect>
          </b-col>
          <b-col v-if="canChangeProfessional">
            <label class="cj-label">Profissional</label>
            <multiselect v-model="confirmationForm.professional" :options="professionals" track-by="name" label="name" :showLabels="false" placeholder="Selecione"></multiselect>
          </b-col>
          <b-col>
            <label class="cj-label w-100">&nbsp;</label>
            <b-button variant="primary" block @click="getConfirmations"><i class="far fa-search"></i> Filtrar</b-button>
          </b-col>
        </b-row>

        <b-row class="header-info">
          <b-col cols="12">
            <div class="box-cj">

              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                  <tr>
                    <th>Data / Hora</th>
                    <th>Profissional</th>
                    <th>Paciente</th>
                    <th>Convênio</th>
                    <th>Status</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="appointment in confirmationData" :key="appointment.id">
                    <td class="align-middle">{{ moment(appointment.start_datetime).format('DD/MM HH:mm') }}</td>
                    <td class="align-middle">{{ appointment.professional.name }}</td>
                    <td class="align-middle">
                      {{ appointment.patient.name }}<br/>
                      <small>
                        {{ appointment.patient.cellphone }}
                      </small>
                    </td>
                    <td class="align-middle">{{ appointment.health_plan.name }}</td>
                    <td class="align-middle" v-html="getStatusTag(appointment.status)"></td>
                    <td class="align-middle"><b-button v-if="appointment.status == 'SCHEDULED' && appointment.patient.cellphone" variant="primary" @click="sendWhatsapp(appointment)">Enviar Whatsapp <i class="fab fa-whatsapp"></i></b-button></td>
                    <td class="align-middle"><b-button v-if="appointment.status == 'SCHEDULED'" variant="success" @click="confirmAppointment(appointment)">Confirmar</b-button></td>
                    <td class="align-middle"><b-button v-if="appointment.status == 'SCHEDULED'" variant="danger" @click="cancelAppointment(appointment)">Cancelar</b-button></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canManage: true,
        canChangeProfessional: false,

        confirmationForm: {
          dateTime: { startDate: this.moment().add('days', 2), endDate: this.moment().add('days', 2) },
          agenda: { value: null, name: 'Todas' },
          professional: { value: null, name: 'Todos' }
        },

        confirmationData: [],

        agendas: [],
        professionals: [{ value: null, name: 'Todos' }],

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        }
      }
    },
    async mounted () {
      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_see');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission('agendas', 'can_manage');

      this.user = JSON.parse(localStorage.getItem('user'));
      this.canChangeProfessional = this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR';

      await this.api.getAgendas({}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.agendas = [{ value: null, name: 'Todas' }];
        console.log(res.data);
        res.data.forEach(agenda => {
          this.agendas.push({ value: agenda.id, name: agenda.name });

          agenda.professionals.forEach(professional => {
            let professionalAlreadyAdded = this.professionals.filter(p => p.value == professional.id);

            if(professionalAlreadyAdded.length == 0)
              this.professionals.push({ value: professional.id, name: professional.name });
          })
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Agendas', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar as suas agendas! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Agendas', err.response);
      });
      if(!this.helpers.isOwner() && this.user.person.type != 'SECRETARY' && this.user.person.type != 'COORDINATOR') {
        this.api.getClient({}).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.canChangeProfessional = res.data.share_patients;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Get Client', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Get Client', err.response);
        });
      }

      this.getConfirmations();
    },
    methods: {
      async getConfirmations() {
        this.eventBus.$emit('IS_LOADING', true);
        let confirmationData = {
          start_date: this.moment(this.confirmationForm.dateTime.startDate).format('YYYY-MM-DD'),
          end_date: this.moment(this.confirmationForm.dateTime.endDate).format('YYYY-MM-DD'),
          agenda: (this.confirmationForm.agenda != null && this.confirmationForm.agenda.hasOwnProperty('value'))?this.confirmationForm.agenda.value:null,
          professional: (this.confirmationForm.professional != null && this.confirmationForm.professional.hasOwnProperty('value'))?this.confirmationForm.professional.value:null
        };

        await this.api.getConfirmations(confirmationData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.confirmationData = res.data;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Confirmations', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }

          this.$swal('Ops...', 'Não conseguimos carregar os dados do consultório! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Confirmations', err.response);
        });
      },
      sendWhatsapp(appointment) {
        window.open('https://wa.me/55'+appointment.patient.cellphone.replace(/\D/g, '')+'?text='+encodeURIComponent(appointment.message));
      },
      async confirmAppointment(appointment) {
        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.confirmAppointment(appointment.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Parabéns...', 'Agendamento confirmado com sucesso!', 'success');

              this.getConfirmations();

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Confirm Appointment', res);
            }).catch(err => {
              try {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;

                let response = err.response;
                let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                this.$swal('Ops...', message, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchConfirmAppointment\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }

              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Confirm Appointment', err.response);
            });
          }
        });
      },
      async cancelAppointment(appointment) {
        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.cancelAppointment(appointment.id, 'this', false).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Parabéns...', 'Agendamento cancelado com sucesso!', 'success');

              this.getConfirmations();

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Cancel Appointment', res);
            }).catch(err => {
              try {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;

                let response = err.response;
                let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                this.$swal('Ops...', message, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchCancelAppointment\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }


              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Cancel Appointment', err.response);
            });

          }
        });
      },
      getStatusTag(status) {
        let color = '';
        let text = '';
        switch (status) {
          case 'SCHEDULED':
            color = '#0F94D8';
            text = 'Agendado';
          break;
          case 'CONFIRMED':
            color = '#28CD6A';
            text = 'Confirmado';
          break;
          case 'CANCELED':
            color = '#CC3F42';
            text = 'Cancelado';
          break;
          case 'MISSED':
            color = '#F5A834';
            text = 'Faltou';
          break;
          case 'SHOWEDUP':
            color = '#674BD0';
            text = 'Compareceu';
          break;
          case 'ATTENDED':
            color = '#C9D5DB';
            text = 'Atendido';
          break;
        }

        return '<span class="tag" style="background-color: '+color+';">'+text+'</span>';
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .confirmation {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }

    .tag {
      width: 100%;
      padding: 5px 15px;
      color: #ffffff;
      border-radius: 15px;
    }

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }
</style>
